import { memo, Profiler, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button, Group } from '@mantine/core';
import { ChevronLeft } from 'lucide-react';
import { useHasPermission } from '../../../providers/AuthProvider';
import { useAdminUser } from '../../../hooks/useAdminUser';
import { UserInfoSection } from '../../../admin/components/UserInfoSection';
import { UserCustomAudioDetail } from '../../../admin/components/UserCustomAudioDetail';

const AdminUserAudioDetail = memo(() => {
  const hasManageProducts = useHasPermission('manage_products');
  const { id, audioId } = useParams<{ id: string; audioId: string }>();
  const adminUserData = useAdminUser();

  const onRenderCallback = useCallback(
    (profilerId: string, phase: string, actualDuration: number) => {
      if (actualDuration > 8) {
        console.warn(
          `🐌 Slow render detected in ${profilerId}: ${phase} took ${actualDuration}ms`
        );
      }
    },
    []
  );

  if (!hasManageProducts) {
    return <div>Non hai i permessi per gestire gli audio personalizzati</div>;
  }

  if (!id || !audioId) {
    return <div>Audio non trovato</div>;
  }

  return (
    <Profiler id='AdminUserAudioDetail' onRender={onRenderCallback}>
      <Group mb='md'>
        <Button
          variant='subtle'
          leftSection={<ChevronLeft size={16} />}
          component={Link}
          to={`/admin/users/${id}/audios`}
        >
          Torna agli audio
        </Button>
      </Group>

      <UserInfoSection
        userInfo={adminUserData.userInfo}
        loadingUserInfo={adminUserData.loadingUserInfo}
      />

      <Profiler id='UserCustomAudioDetail' onRender={onRenderCallback}>
        <UserCustomAudioDetail userId={id} audioId={audioId} />
      </Profiler>
    </Profiler>
  );
});

AdminUserAudioDetail.displayName = 'AdminUserAudioDetail';

export default AdminUserAudioDetail;
